import StringHelper from 'utilities/stringHelper';

const isAscending = array =>
    array.every((element, index) => {
        const nextValue = array[index + 1];
        return nextValue ? element === nextValue - 1 : true;
    });

const isDescending = array =>
    array.every((element, index) => {
        const nextValue = array[index + 1];
        return nextValue ? element === nextValue + 1 : true;
    });

export const createAscendingOrDescendingValidation = minLength => ({
    name: 'AscendingOrDescending',
    validationFunction: value => {
        if (value.length < minLength) return false;
        const splitValue = value.split('').map(value => Number(value));
        return isAscending(splitValue) || isDescending(splitValue);
    },
});

export const createRepeatedValidation = () => ({
    name: 'Repeated',
    validationFunction: StringHelper.hasCharacterRepeatedMoreThanTwice,
});

export const createBirthdayValidation = ({ day, month, year }) => ({
    name: 'Birthday',
    validationFunction: value => {
        return value.includes(year) || value.includes(day + month) || value.includes(month + day);
    },
});
